import './css/NavBar.css';
import logo from '../assets/images/logo.png';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavBar = ({auth, logout}) => {
    const navigate = useNavigate(); // ✅ Hook at top level
    const [showOptions, setShowOptions] = useState(false)

    const handleClick = () => {
        navigate('/'); // ✅ Call the function inside event handler
    };

    const openOptions = () => {
        setShowOptions(!showOptions)
    }

    return (
        <nav>
            <div className="logo" onClick={handleClick}>
                <img src={logo} alt="" />
                autocommitter
            </div>
            {/* <div className='project-name'>project name</div> */}
            {auth &&
                <div className="left">
                    {auth?.login}
                    <img src={auth?.avatar_url} alt="" onClick={openOptions}/>

                    <div className= {`options ${showOptions ? 'active' : ''}`}>
                        <div className="logout" onClick={logout}>logout</div>
                    </div>
                </div>
            }
        </nav>
    );
}

export default NavBar;